import React from 'react'
import {ApiRequest} from '../../../../../../services/api/api'
import {SuborderCommonModal} from './suborder-common-modal/suborder-common-modal'
import SweetAlertService from '../../../../../../services/lib/utils/sweet-alert-service'

export const SuborderCompleteModal = (props: {visible: any, onOk: any, onCancel: any, data: any, machine: any, isPackaging?: boolean, updateValueFn?: any, isNotRequiredPassword?: boolean}) => {
  const {visible, onOk, onCancel, data, machine, isPackaging, updateValueFn} = props

  const onFinish = (value: any, isFull: boolean) => {
    const { pendingExceptionalLog, ...requestData } = value
    ApiRequest({
      url: 'Suborder/' + (isFull ? 'Finish' : 'PartlyComplete') + 'Suborder?id=' + data.suborderId,
      method: 'put',
      data: {
        ...requestData,
        machineId: machine.machineId
      }
    }).then(async _ => {
      // 完成接口提交成功后，才写入非常规操作日志（提交失败走 catch，不会记录）
      if (pendingExceptionalLog) {
        await SweetAlertService.addExceptionalLog(
          pendingExceptionalLog.page,
          pendingExceptionalLog.triggerReason,
          pendingExceptionalLog.reason,
          pendingExceptionalLog.createBy
        )
      }
      await SweetAlertService.successMessage()
      onOk()
    })
  }

  const submitHandler = async (value: any) => {
    let newValue = value
    if (updateValueFn) {
      newValue = await updateValueFn(value)
      if (newValue == 'err') {
        return
      }
      console.log(newValue)
    }
    onFinish(newValue, !!(value.submitType === '1' || isPackaging))
  }

  return (
    <SuborderCommonModal
      visible={visible}
      onOk={submitHandler}
      onCancel={onCancel}
      data={data}
      machine={machine}
      isPackaging={isPackaging}
      isComplete={true}
      isNotRequiredPassword={props.isNotRequiredPassword}
    />
  )
}
